import React, { useState, useEffect } from "react";
import {
  Select,
  SelectOption,
  Heading,
  Hint,
  Collapsible,
  CollapsibleHeading,
  CollapsibleContent,
} from "@americanexpress/dls-react";
import { useTranslation } from "react-i18next";
import ArrowIcon from "../../assets/Arrow.svg";
import {
  COUNTRY, APPROVER_OPTIONS,
  TRUE, APPROVER_LIST_MAP,
} from "../Common/constants";
import { isLanguageEnglish, getUserAccess } from "../Common/utils";
import ApproverList from './ApproverList';
import "./AccessApprovalStyle.css";

const AccessApprovalItem = (props) => {
  const { t } = useTranslation("common");
  const {
    index,
    user,
    usersmain,
    i18n,
    submit,
    value,
    getUser,
    locationState,
    setValue,
  } = props;

  const [accessState, setAccessState] = useState({
    functName: '',
    functRole: '',
    userCountry: '',
    onlyUKAccess: false,
    isAPACAndUKAccess: false,
  });
  const [approversList, setApproversList] = useState([1]);
  const [approverData, setApproverData] = useState(props.value || []);
  const [authorizedSignatories, setAuthorizedSignatories] = useState(user?.authorizedSignatories || []);

  const accessTitle = localStorage.getItem("modify") === TRUE ? t("access.modifyaccessfor") : t("access.accessfor");
  const accessName = isLanguageEnglish(i18n.language) ? ` ${user.firstName} ${user.lastName}` : ` ${user.lastName} ${user.firstName} `;
  const accessFullTitle = `${accessTitle} ${index + 1} - ${accessName}`;

  const handleApproverChange = (targetValue, position) => {
    const valueInt = parseInt(targetValue, 10);
    setAuthorizedSignatories((prev = []) => {
      const next = prev.slice(0, valueInt);
      while (next.length < valueInt) next.push({});
      return next;
    });
    updateSelectorData(position, targetValue);
  };

  const checkUserAccess = () => {
    setAccessState(getUserAccess(t, accessState, user));
    const approvers = APPROVER_LIST_MAP[user?.country] || APPROVER_OPTIONS.DEFAULT;
    setApproversList(approvers);
  };

  useEffect(() => {
    setApproverData(value);
  }, [value]);

  useEffect(() => {
    checkUserAccess();
    handleApproverChange(user?.authorizedSignatoriesCount || 1, index);
    updateSelectorData(index, user?.authorizedSignatoriesCount || 1);
  }, []);

  const updateSelectorData = (position, targetValue) => {
    setApproverData((prev) => {
      const newValue = [...prev];
      newValue[position] = targetValue;
      setValue(newValue);
      return newValue;
    });
  };

  return (
    <Collapsible defaultOpen={[index]}>
      <div className="pad-1-tb" key={index}>
        <CollapsibleHeading
          id={index}
          className="dls-bright-blue-bg dls-white collapseBlueHeader"
          defaultBtn={true}
        >
          <div className="row pad-1">
            <div className="col-sm-6 text-align-left">
              {accessFullTitle}
            </div>
            <div className="col-sm-6 text-align-right">
              {t("access.viewdetails")} <img src={ArrowIcon} alt="arrowicon" />
            </div>
          </div>
        </CollapsibleHeading>

        <CollapsibleContent labelledBy={index} className="openCollapse max-height-auto">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-rounded pad-1">
                <Heading level={4} className="heading-4 dls-deep-blue pad-1-b">
                  {accessFullTitle}
                  {user.selfenroll === "2"
                    ? t("access.newsetupmod")
                    : t("access.selfenrolladd")}
                </Heading>
                <p>
                  <span>
                    {t("access.choose")} {t("newuser.user")}-{index + 1}
                  </span>
                  <span className="spanField">
                    <Select
                      id={index + 1}
                      value={approverData[index]}
                      onChange={(event) => {
                        handleApproverChange(event.target.value, index);
                      }}
                    >
                      {approversList.map((acc) => (
                        <SelectOption key={`${acc?.country}-${acc}`} value={acc}>
                          {acc}
                        </SelectOption>
                      ))}
                    </Select>
                  </span>
                </p>
                {accessState.userCountry === COUNTRY.INDIA &&
                  accessState.functName === t("products.functname2") &&
                  accessState.functRole === t("products.role-approver") ? (
                  <div className="accesstext">
                    {t("newuser.accessApprovalInfoMsg")}
                    <p className="accesstext_India">{t("newuser.accesstext_India")}</p>
                  </div>
                ) : (
                  <div className="pad-2-b">
                    <Hint>{t("newuser.accessApprovalInfoMsg")}</Hint>
                  </div>
                )}
                <ApproverList
                  authorizedSignatories={authorizedSignatories}
                  approverData={approverData}
                  index={index}
                  user={user}
                  usersmain={usersmain}
                  accessState={accessState}
                  getUser={getUser}
                  locationState={locationState}
                  submit={submit}
                />
              </div>
            </div>
          </div>
        </CollapsibleContent>
      </div>
    </Collapsible>
  );
}

export default AccessApprovalItem;
